// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6935) return "static/chunks/6935-0736197b86543ff9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"9272":"cb56af6ea5ba1e70","9724":"0ea340933afbc54f"}[chunkId] + ".js";
};